"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _utils = require("../../utils");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var styleByWidth = (0, _utils.stylesBy)(function (props) {
  return props.size;
});
var width = styleByWidth({
  sm: '20px',
  lg: '40px'
}, '30px');
var SpinnerWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  flex-grow: 1;\n"])));
var Spinner = (0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(SpinnerWrapper, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Spinner, props));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", " !important;\n  border-right-color: ", ";\n  width: ", ";\n  height: ", ";\n  border-width: 3px;\n"])), function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return theme.colors[color] + '30';
}, function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color;
  return theme.colors[color];
}, width, width);
exports.Spinner = Spinner;